export default __webpack_public_path__ + "static/media/icon_warning.f233cd1b.png";